import React, { useState } from 'react';
import styles from './index.module.scss';

import Step from '../../components/Step/Step';
import Button from '../../components/Button/Button';
import CtaWrapper from '../../components/CtaWrapper/CtaWrapper';
import Logo from '../../components/Logo/Logo';
import TemplateFull from '../../components/TemplateFull/TemplateFull';
import { trackEvent } from '../../services/analyticsService';

import { StepData } from '../../types/step';

import intro_img_url from '../../assets/images/premi-friends.png';

import Carousel from '../../components/Carousel/Carousel';

import 'swiper/css';
import 'swiper/css/autoplay';

import imageBorsa from '../../assets/images/premio-borsa.png';
import imageMagliettaRossa from '../../assets/images/premio-tshirt-red.png';
import imageMagliettaBianca from '../../assets/images/premio-tshirt-white.png';
import imageFelpa from '../../assets/images/premio-felpa-red.png';
interface IntroPageProps {
  changeStep: (step: StepData) => void;
}

const IntroPage: React.FC<IntroPageProps> = ({ changeStep }) => {

  const [disabledButton, setDisabledButton] = useState(false);

  const handleNext = () => {
    setDisabledButton(true);
    // let tutorialCompleted = localStorage.getItem('tutorialCompleted') || 'false';
    // if (tutorialCompleted === 'true') {
    trackEvent('Partecipa', 'Partecipa - Click');
    changeStep('home');
    // } else {
    //   changeStep('tutorial-first-time');
    // }
  };

  return (
    <Step>
      <TemplateFull heightFull={true} legalLine="simple">
        <div className={styles.Content}>
          <div className={styles.ContentInner}>
            <Logo type="full" />
            {/* <h2 className='boxed'>
              Come funziona?
            </h2> */}
            <p>
              Inquadra il QR Code sugli schermi dietro al McCafé® o alle casse del McDonald’s, rispondi alle 3 domande del Quiz e, comunque vada,<br />
              <strong>prova a vincere uno dei premi a tema Friends!</strong>
            </p>
            <div className={styles.wrapperCarousel}>
              <Carousel
                  slidesPerView={1}
                  spaceBetween={16}
                  loop={true}
                  effect='fade'
                  pagination={false}
                  navigation={true}
                  className={styles.contestsCarousel}
                >
              <img src={imageBorsa} alt="Borsa" />
              <img src={imageMagliettaRossa} alt="Maglietta Rossa" />
              <img src={imageMagliettaBianca} alt="Maglietta Bianca" />
              <img src={imageFelpa} alt="Felpa" />
            </Carousel>
            </div>
              
            {/* <img src={intro_img_url} alt="Premi Friends" /> */}
          </div>
          {/* <Toys /> */}
          <CtaWrapper>
            <Button disabled={disabledButton} onClick={() => handleNext()}>Partecipa ora</Button>
          </CtaWrapper>
        </div>
      </TemplateFull>
    </Step>
  );
};

export default IntroPage; 